import React, { useEffect, useRef, useState } from 'react';

import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import CarouselArtistTemplate from './CarouselArtistTemplate';

const ArtistCarousel = (props) => {

    const [itemWidth, setItemWidth] = useState(250);
    const itemHeight = 410;

    const ref = useRef(null);
    const [showCount, setShowCount] = useState(null);

    const responsive = {
        0: { items: 1 },
        568: { items: 2 },
        1024: { items: 3 },
    };


    useEffect(() => {
        function handleResize() {
            let _itemWidth = itemWidth;
            if (ref.current.offsetWidth < itemWidth) {
                _itemWidth = ref.current.offsetWidth;
                setItemWidth(_itemWidth);
            }
            let _show = ref.current.offsetWidth / _itemWidth;
            console.log("getShow size width", ref.current.offsetWidth, _itemWidth, _show);
            setShowCount(_show);
        }
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    const handleDragStart = (e) => e.preventDefault();

    const items = [
        <img src="path-to-img" onDragStart={handleDragStart} role="presentation" />,
        <img src="path-to-img" onDragStart={handleDragStart} role="presentation" />,
        <img src="path-to-img" onDragStart={handleDragStart} role="presentation" />,
    ];

    /*
      props.data.map((param, index) => {
                  //
                  return (
                      <div key={index} style={{ width: 250, height: 410 }}>
                          {carouselItemTemplate(param, (param.length - 1) == index)}

                      </div>
                  )
              })
    */



    const getItems = () => {

        let _items = [];
        props.data.map((param, index) => {
            _items.push(
                <div key={index} style={{ width: itemWidth, height: itemHeight }}>
                    <CarouselArtistTemplate exhibition={param} isLast={(props.data.length - 1) == index} />


                </div>
            )
        })
        return _items;

    }

    const renderCarosel = () => {
        if (!showCount) {
            return <></>
        }


        return (

            <AliceCarousel mouseTracking items={getItems()} slidesToShow={showCount} slidesToScroll={1} responsive={responsive}
                disableDotsControls
                disableButtonsControls
                autoWidth
            />

        );
    }



    return (
        <div ref={ref}>
            <div style={{ background: 'linear-gradient(rgb(0,0,0,0), rgb(0, 0,0,0.7))', }}></div>
            {renderCarosel()}
        </div>
    );
};

export default ArtistCarousel;
